import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { SURVEY_STATISTICS } from "../../../GraphQL/Queries";
import NotificationManager from "react-notifications";
import { ContentUsers, ContentStatistics } from "./UserResume.styled";
import PropTypes from "prop-types";

const UserResume = ({ idSurvey }) => {
  const [Statistics, setStatistics] = useState();
  const [getSurveyStatistics] = useLazyQuery(SURVEY_STATISTICS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data.surveyStatistics.withError) {
        NotificationManager.error("Error to charge information", "", 8000);
      } else {
        setStatistics(data.surveyStatistics.outputData);
      }
    },
  });

  useEffect(() => {
    getSurveyStatistics({
      variables: { surveyId: idSurvey },
    });
  }, [idSurvey]);

  return (
    <>
      {Statistics && (
        <ContentUsers>
          <ContentStatistics>
            <span>{Statistics.usersAssigned}</span>
            <br />
            <span>Assigned Users</span>
          </ContentStatistics>
          <ContentStatistics>
            <span>{Statistics.surveysResponded}</span>
            <br />
            <span>Have answered</span>
          </ContentStatistics>
          <ContentStatistics>
            <span>{Statistics.surveysRemaining}</span>
            <br />
            <span>Remaining users to answer</span>
          </ContentStatistics>
        </ContentUsers>
      )}
    </>
  );
};
export default UserResume;

UserResume.propTypes = {
  idSurvey: PropTypes.number.isRequired,
};
